import  { useEffect, useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { relTissueTranslate, tissueTranslate, backboneTranslate } from './dictionaries';


export default function AllelicCurationOverview(props: any) {
    const { refId, exprItem, index } = props;
    const [allelicCurationData, setAllelicCurationData] = useState<any>([]);





    useEffect(() => {
        if (!exprItem) {
            return;
        }
        const fetchData = async () => {
            if (exprItem.allelic_curation && exprItem.allelic_curation.length > 0) {
                let dataInput = exprItem.allelic_curation[index];
                //now for rel_tissue translation
                if (dataInput['rel_tissue'] && dataInput['rel_tissue'] !== null) {
                    let tis_orig = dataInput['rel_tissue'].split(";");
                    for (let i = 0; i < tis_orig.length; i += 1) {
                        tis_orig[i] = tissueTranslate(tis_orig[i], "label");
                    }
                    dataInput['rel_tissue'] = tis_orig.join("; ");
                }
                else {
                    dataInput['rel_tissue'] = 'N/A';
                }
                if(dataInput['rel_tissue_value'] && dataInput['rel_tissue_value'] != null) {
                let tis_val_orig = dataInput['rel_tissue_value'].split(";");

                for (let i = 0; i < tis_val_orig.length; i += 1) {
                    tis_val_orig[i] = relTissueTranslate(tis_val_orig[i]);
                }
                dataInput['rel_tissue_value'] = tis_val_orig.join("; ");
            }
            else {
                dataInput['rel_tissue_value'] = 'N/A';
            }
            if(dataInput['backbone'] === '-') {
                dataInput['promoter'] = '-';
                dataInput['transgenesisType'] = '-';
            }
            else {
                dataInput['promoter'] = backboneTranslate(dataInput['backbone'], 'promoter');
                dataInput['transgenesisType'] = backboneTranslate(dataInput['backbone'], 'transgenesisType');
            }
            //URL formatting
            let allelicUrl = null;
            let altElementUrl = null;
            if(dataInput["refExp"] !== dataInput["altExp"]) {
                var altId = dataInput["id"]
                if(dataInput["id"] === "-") {
                    altId = refId;
                }
                allelicUrl = "/vista/curation?refId="+refId+"&altId="+altId+"&refExp="+dataInput["refExp"]+"&altExp="+dataInput["altExp"];
                let altIdentifiers = altId.split(".");
                altElementUrl = "/vista/element?vistaId="+altIdentifiers[0]+"&alleleId="+altIdentifiers[1];
                if(dataInput["stage"] !== "-") {
                    altElementUrl += "&stage="+dataInput["stage"];
                } else {
                    altElementUrl += "&stage="+exprItem["stage"];
                }
                if(dataInput["backbone"] !== "-") {
                    altElementUrl += "&backbone="+dataInput["backbone"];
                } else {
                    altElementUrl += "&backbone="+exprItem["backbone"];
                }
                
                
            }
            dataInput['comparison_url'] = allelicUrl;
            dataInput['alt_element_url'] = altElementUrl;
            setAllelicCurationData(dataInput);
            }
        };
        fetchData()
            .catch((error) => {
            });
    }

    );

    const allelicLink = () => {
        let link = null;
        if(allelicCurationData["comparison_url"]) {
            link = <a className="btn btn-warning btn-sm" href={allelicCurationData["comparison_url"]} rel='noreferrer'>Compare Experiments</a>;
        }
        else {
            link = "-";
        }
        return link;
    }

    const altExperimentLink = () => {
        let link = null;
        if(allelicCurationData["alt_element_url"]) {
            link = <a className="btn btn-primary btn-sm" href={allelicCurationData["alt_element_url"]} rel='noreferrer'>View Alternative</a>;
        }
        else {
            link = "-";
        }
        return link;       

    }

    if (!allelicCurationData )
        return null;

    return (

                <TableRow>
                    <TableCell>
                    {allelicCurationData["id"]}
                    </TableCell>
                    <TableCell>
                    {allelicCurationData["organism"]}
                    </TableCell>
                    <TableCell>
                    {allelicCurationData["description"]}
                    </TableCell>
                    <TableCell>
                        {allelicCurationData["backbone"]}
                    </TableCell>
                    <TableCell>
                        {allelicCurationData["promoter"]}
                    </TableCell>
                    <TableCell>
                        {allelicCurationData["transgenesisType"]}
                    </TableCell>
                    <TableCell>
                        {allelicCurationData["stage"]}
                    </TableCell>
                    <TableCell>
                        {allelicCurationData["rel_comparison"]}
                    </TableCell>
                    <TableCell>
                        {altExperimentLink()}
                    </TableCell>
                    <TableCell>
                        {allelicLink()}
                    </TableCell>
                </TableRow>

    );
}